"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceInventoryMode = exports.ServiceMode = exports.ServiceRegionDefinition = exports.ServiceCategory = exports.ServiceType = void 0;
var ServiceType;
(function (ServiceType) {
    ServiceType["BENEFIT"] = "benefit";
    ServiceType["MODE"] = "mode";
    ServiceType["PROGRAM"] = "program";
    ServiceType["AMENITY"] = "amenity";
    ServiceType["CARBON_OFFSET"] = "carbon_offset";
})(ServiceType || (exports.ServiceType = ServiceType = {}));
var ServiceCategory;
(function (ServiceCategory) {
    ServiceCategory["DRIVE"] = "drive";
    ServiceCategory["SHARED_RIDE"] = "shared_ride";
    ServiceCategory["PUBLIC_TRANSIT"] = "public_transit";
    ServiceCategory["BIKE"] = "bike";
    ServiceCategory["WALK"] = "walk";
    ServiceCategory["REMOTE"] = "remote";
    ServiceCategory["CARPOOL"] = "carpool";
})(ServiceCategory || (exports.ServiceCategory = ServiceCategory = {}));
var ServiceRegionDefinition;
(function (ServiceRegionDefinition) {
    ServiceRegionDefinition["HOME_ONLY"] = "homeOnly";
    ServiceRegionDefinition["WORK_ONLY"] = "workOnly";
    ServiceRegionDefinition["HOME_AND_WORK"] = "homeAndWork";
})(ServiceRegionDefinition || (exports.ServiceRegionDefinition = ServiceRegionDefinition = {}));
var ServiceMode;
(function (ServiceMode) {
    ServiceMode["DRIVING"] = "driving";
    ServiceMode["CARSHARING"] = "carsharing";
    ServiceMode["CARPOOL_PASSENGER"] = "carpool_passenger";
    ServiceMode["CARPOOL_DRIVER"] = "carpool_driver";
    ServiceMode["RIDESHARING"] = "ridesharing";
    ServiceMode["VANPOOL"] = "vanpool";
    ServiceMode["SHUTTLE"] = "shuttle";
    ServiceMode["WALKING"] = "walking";
    ServiceMode["TAXI"] = "taxi";
    ServiceMode["BICYCLING"] = "bicycling";
    ServiceMode["BIKESHARING"] = "bikesharing";
    ServiceMode["SCOOTER"] = "scooter";
    ServiceMode["SHAREDSCOOTER"] = "sharedScooter";
    ServiceMode["BUS"] = "bus";
    ServiceMode["TRAIN"] = "train";
    ServiceMode["SUBWAY"] = "subway";
    ServiceMode["FERRY"] = "ferry";
    ServiceMode["TRAMWAY"] = "tramway";
    ServiceMode["REMOTE"] = "remote";
    ServiceMode["OTHER_TRANSIT"] = "other_transit";
    ServiceMode["PARKING"] = "parking";
})(ServiceMode || (exports.ServiceMode = ServiceMode = {}));
/**
 * Defines how inventory items are quantified within a plan:
 * - UNRESTRICTED: No quantity limit applies
 * - INDIVIDUAL: One item per row (1:1 relationship)
 * - GROUPED: Multiple items can be grouped together with a specific quantity
 */
var ServiceInventoryMode;
(function (ServiceInventoryMode) {
    ServiceInventoryMode["UNRESTRICTED"] = "unrestricted";
    ServiceInventoryMode["INDIVIDUAL"] = "individual";
    ServiceInventoryMode["GROUPED"] = "grouped";
})(ServiceInventoryMode || (exports.ServiceInventoryMode = ServiceInventoryMode = {}));
//# sourceMappingURL=Service.js.map